import React from 'react';

const ScannerHeader = ({ assetCount }) => {
  const now = new Intl.DateTimeFormat('fr-FR', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(new Date());

  return (
    <div className="scanner-header">
      <div className="scanner-header__heading">
        <div>
          <div className="scanner-header__eyebrow">Scanner global</div>
          <h2>Asset Scanner</h2>
          <p>
            Vue synthétique du flux d’actifs analysés, avec lecture rapide du volume traité,
            de la cadence de rafraîchissement et des segments à venir.
          </p>
        </div>
        <div className="scanner-header__stamp">
          <span className="scanner-header__stamp-label">Dernière mise à jour</span>
          <span>{now}</span>
        </div>
      </div>

      <div className="scanner-header__kpis">
        <div className="scanner-header__kpi">
          <span className="scanner-header__kpi-label">Actifs analysés</span>
          <strong>{assetCount}</strong>
        </div>
        <div className="scanner-header__kpi">
          <span className="scanner-header__kpi-label">Segmentation</span>
          <strong>Vue globale</strong>
        </div>
        <div className="scanner-header__kpi">
          <span className="scanner-header__kpi-label">Univers prévu</span>
          <strong>Top 50 / 200 / Sectoriel</strong>
        </div>
      </div>
    </div>
  );
};

export default ScannerHeader;
